export default __webpack_public_path__ + "static/media/img-1.26ed3b03.jpg";